import { createFileRoute } from '@tanstack/react-router';
import { queryClient } from '@/lib/utils/queryClient';
import { CompanyApiKeysTab } from '../../../-components/CompanyApiKeysTab';
import { companyApiKeysQueryOptions } from '../../../-hooks/useCompanyApiKeys';
import { DEFAULT_PAGE_SIZE } from '../../../-utils/pagination';

export const Route = createFileRoute(
  '/management/companies/(pages)/$companyId/api-keys/',
)({
  loader: ({ params }) =>
    queryClient
      .ensureQueryData(
        companyApiKeysQueryOptions({
          companyId: params.companyId,
          page: 1,
          limit: DEFAULT_PAGE_SIZE,
        }),
      )
      // A failed prefetch must not blank the tab — the component's own query
      // re-runs and surfaces the error inline.
      .catch(() => undefined),
  component: CompanyApiKeysPage,
});

function CompanyApiKeysPage() {
  const { companyId } = Route.useParams();
  return <CompanyApiKeysTab companyId={companyId} />;
}
